import "./index.scss"

const GAM_SLOT_SELECTOR = ".affiliate-bar__blue-bar-item[id^='cont_bn_blue_bar']"
const MAX_OBSERVER_MS = 60000
const QUIET_PERIOD_MS = 5000

function hideParentListItem(slotDiv: HTMLElement): void {
  const listItem = slotDiv.closest("li.gam-unit-blue-bar") as HTMLElement | null
  if (!listItem) return

  listItem.style.display = "none"
}

function showParentListItem(slotDiv: HTMLElement): void {
  const listItem = slotDiv.closest("li.gam-unit-blue-bar") as HTMLElement | null
  if (!listItem) return

  listItem.style.removeProperty("display")
}

function shouldHideSlot(slotDiv: HTMLElement): boolean {
  const lifecycle = slotDiv.getAttribute("data-adbridg-slot-lc") ?? ""
  const isMarkedUnfilled = /rendered=unfilled/.test(lifecycle)
  const isMarkedFilled = /rendered=filled/.test(lifecycle)
  const hasCreativeElements = !!slotDiv.querySelector("iframe, a[href], img[src]")
  const isHidden =
    slotDiv.style.display === "none" || window.getComputedStyle(slotDiv).display === "none"

  if (isMarkedFilled || hasCreativeElements) return false

  return isMarkedUnfilled || (isHidden && !hasCreativeElements)
}

function hideEmptyGamSlots(): void {
  document.querySelectorAll<HTMLElement>(GAM_SLOT_SELECTOR).forEach((slotDiv) => {
    if (shouldHideSlot(slotDiv)) {
      hideParentListItem(slotDiv)
    } else {
      showParentListItem(slotDiv)
    }
  })
}

function haveGamSlotsSettled(): boolean {
  const slots = document.querySelectorAll<HTMLElement>(GAM_SLOT_SELECTOR)
  if (slots.length === 0) return false

  return Array.from(slots).every((slotDiv) => {
    const lifecycle = slotDiv.getAttribute("data-adbridg-slot-lc") ?? ""
    const isResolvedByLifecycle = /rendered=(filled|unfilled)/.test(lifecycle)
    const hasCreativeElements = !!slotDiv.querySelector("iframe, a[href], img[src]")

    return isResolvedByLifecycle || hasCreativeElements
  })
}

function watchGamSlotUpdates(): void {
  const list = document.querySelector(".affiliate-bar__list")
  if (!list) return

  let quietTimer: number | undefined
  let maxTimer: number | undefined

  function disconnectObserver(obs: MutationObserver): void {
    obs.disconnect()
    if (quietTimer) window.clearTimeout(quietTimer)
    if (maxTimer) window.clearTimeout(maxTimer)
  }

  const observer = new MutationObserver(() => {
    hideEmptyGamSlots()

    if (haveGamSlotsSettled()) {
      disconnectObserver(observer)
      return
    }

    if (quietTimer) window.clearTimeout(quietTimer)
    quietTimer = window.setTimeout(() => {
      hideEmptyGamSlots()
      disconnectObserver(observer)
    }, QUIET_PERIOD_MS)
  })

  observer.observe(list, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["style", "data-adbridg-slot-lc"],
  })

  if (haveGamSlotsSettled()) {
    disconnectObserver(observer)
    return
  }

  quietTimer = window.setTimeout(() => {
    hideEmptyGamSlots()
    disconnectObserver(observer)
  }, QUIET_PERIOD_MS)

  // Hard upper bound in case slots never settle.
  maxTimer = window.setTimeout(disconnectObserver, MAX_OBSERVER_MS)
}

function runWhenReady(): void {
  const runChecks = () => {
    hideEmptyGamSlots()
    watchGamSlotUpdates()
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runChecks)
  } else {
    runChecks()
  }
}

runWhenReady()
